<template>
  <svg width="6.438" height="32">
    <path d="M.937 19.132a8.717 9.999 0 0 1 0-6.253L4.3 1.166a.84.963 0 0 1 1.639.313v29.043a.845.969 0 0 1-1.647.313z" fill="#F7FCFF" stroke="currentColor"/>
  </svg>
</template>
